// [AUDIT-2026-10-28 L-OPEN-8] The platform contact (e-mail, phone) as the
// super admin set it in platform settings. Never hardcoded (CLAUDE.md #22).
// One request per page load, shared by every component that asks.
import { useEffect, useState } from 'react';
import { publicApi } from '../services/apiService';

let pending = null;

export function loadPlatformContact() {
  if (!pending) pending = publicApi.contact().catch(() => { pending = null; return {}; });
  return pending;
}

export default function usePlatformContact() {
  const [contact, setContact] = useState({});
  useEffect(() => {
    let alive = true;
    loadPlatformContact().then((c) => { if (alive) setContact(c || {}); });
    return () => { alive = false; };
  }, []);
  return contact;
}
